var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 25.679v4.554c0 1.547-4.125 2.836-9.194 2.836-5.07 0-9.109-1.246-9.109-2.793v-.516l-.086-3.609h.043c.688 1.332 4.469 2.363 9.023 2.363 4.554 0 9.237-1.288 9.237-2.835H40z",
    fill: "#E2A63B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.548 8.75v4.512h-.086c0 1.59-4.253 2.836-9.28 2.836a22.05 22.05 0 0 1-5.8-.645l-.086.086a10.039 10.039 0 0 0-3.18-1.761v-.086l-.129-4.77c.301 1.461 4.297 2.621 9.152 2.621 4.855 0 9.323-1.246 9.323-2.792h.086z",
    fill: "#F4B844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.548 8.837c0 1.546-4.254 2.792-9.323 2.792-5.07 0-8.894-1.16-9.195-2.62 0-.043-.043-.13-.043-.172C11.987 7.29 16.112 6 21.225 6c5.112-.043 9.323 1.246 9.323 2.836z",
    fill: "#FEDB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.654 26.151-.043-.945-.086-3.867c.301 1.461 4.297 2.621 9.152 2.621 4.855 0 9.151-1.246 9.28-2.75H40v4.469h-.086c0 1.546-4.168 2.835-9.237 2.835-5.07 0-8.335-1.03-9.023-2.363z",
    fill: "#F4B844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.51 29.03c1.16-1.074 2.063-2.45 2.535-3.953h.215c.945.086 1.89.13 2.922.13h.43v.944l.085 3.61h-.472c-1.89.042-3.738-.173-5.586-.602l-.129-.13z",
    fill: "#E2A63B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.654 20.996v.214l.086 3.996h-.43a33.04 33.04 0 0 1-3.007-.129h-.215c.301-.902.43-1.847.43-2.792 0-.645-.086-1.246-.215-1.848h.215c.902.086 1.804.129 2.793.129l.386.215c-.043.086-.043.172-.043.215z",
    fill: "#F4B844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.382 15.453a22.05 22.05 0 0 0 5.8.645c5.027 0 9.28-1.246 9.28-2.836h.086v5.07c-4.683 0-8.507 1.117-8.98 2.535l-.386-.215c-.945 0-1.848-.043-2.707-.129h-.215a8.672 8.672 0 0 0-2.964-5.027l.086-.043z",
    fill: "#E2A63B"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FEDB41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.346 20.523a9.404 9.404 0 0 0-3.05-5.113 8.164 8.164 0 0 0-3.266-1.804c-.859-.301-1.804-.43-2.706-.43C4.21 13.133.044 17.215 0 22.327c-.043 5.113 4.039 9.28 9.152 9.324 2.363 0 4.597-.86 6.358-2.45a9.33 9.33 0 0 0 2.578-4.081c.301-.902.43-1.805.43-2.75 0-.601-.172-1.246-.172-1.847zM39.957 21.124v.086c-.129 1.504-4.296 2.75-9.28 2.75-4.984 0-8.85-1.16-9.152-2.62v-.215c0-.086 0-.172.043-.258.473-1.418 4.297-2.535 8.98-2.535h.129c5.07 0 9.28 1.246 9.28 2.792z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.324 21.253a1.43 1.43 0 0 1-1.418-1.418 1.43 1.43 0 0 1 1.418-1.417 1.43 1.43 0 0 1 1.417 1.417c0 .473.387.86.86.86.472 0 .859-.387.859-.86 0-1.374-.945-2.62-2.277-3.007v-.344a.862.862 0 0 0-.86-.859.862.862 0 0 0-.859.86v.343a3 3 0 0 0-2.277 3.007 3.154 3.154 0 0 0 3.137 3.137 1.43 1.43 0 0 1 1.417 1.418 1.43 1.43 0 0 1-1.417 1.418 1.43 1.43 0 0 1-1.418-1.418.862.862 0 0 0-.86-.86.862.862 0 0 0-.859.86c0 1.418.945 2.62 2.277 3.007v.688c0 .472.387.859.86.859.472 0 .859-.387.859-.86v-.687c1.675-.472 2.62-2.234 2.105-3.91-.387-1.288-1.59-2.234-2.964-2.234z",
    fill: "#E2A63B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaked);
export default __webpack_public_path__ + "static/media/staked.721dd25c.svg";
export { ForwardRef as ReactComponent };